import { Svg } from 'components/svg'
import type { IconType } from 'models'

export const IconInstagram: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 512 512">
    <g fill="currentColor" transform="translate(120.723 119.323)">
      <path
        d="M83.878,16.7a68.478,68.478,0,1,0,68.478,68.478C152.356,47.729,121.327,16.7,83.878,16.7Zm0,112.347a43.869,43.869,0,1,1,43.869-43.869A44.067,44.067,0,0,1,83.878,129.047Z"
        transform="translate(52.198 51.763)"
      />
      <circle
        cx="15.515"
        cy="15.515"
        r="15.515"
        transform="translate(191.715 51.344)"
      />
      <path
        d="M247.354,26.734C233.444,12.29,213.65,4.8,191.18,4.8H80.973C34.429,4.8,3.4,35.829,3.4,82.373V192.045c0,23,7.49,42.8,22.469,57.244,14.445,13.91,33.7,20.864,55.639,20.864H190.645c23,0,42.264-7.49,56.174-20.864,14.445-13.91,21.934-33.7,21.934-56.709V82.373C268.753,59.9,261.263,40.644,247.354,26.734Zm-2.14,165.846c0,16.585-5.885,29.959-15.515,39.054s-23,13.91-39.054,13.91H81.508c-16.05,0-29.424-4.815-39.054-13.91-9.63-9.63-14.445-23-14.445-39.589V82.373c0-16.05,4.815-29.424,14.445-39.054,9.095-9.095,23-13.91,39.054-13.91H191.715c16.05,0,29.424,4.815,39.054,14.445,9.095,9.63,14.445,23,14.445,38.519V192.58Z"
        transform="translate(0 0)"
      />
    </g>
  </Svg>
)
